import path from 'ramda/src/path'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import { projectDeliveredKey } from 'root/src/shared/constants/keys'
import { APPROVE_DELIVERY } from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'
import { REVIEW_DELIVERY } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { PENDING_DELIVERIES_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { REVIEW_DELIVERY_OPTIONS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { getProductAmount } from 'root/src/shared/util/getProductAmount'

const isProjectRewardAvailable = (project) => {
	const { brandProduct } = project
	const neededAmount = brandProduct.amount
	return getProductAmount(brandProduct) >= neededAmount
}

export default {
	[APPROVE_DELIVERY]: {
		endpointId: REVIEW_DELIVERY,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['audit', projectDeliveredKey],
		],
		label: 'Approve dare',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectDeliveredKey,
			},
		],
		onSuccessRedirect: { routeId: PENDING_DELIVERIES_ROUTE_ID },
		verificationFn: ({
			recordClickActionId,
			recordId,
			actionPayload,
			state,
			dispatch,
		}) => {
			const project = path(['api', 'records', 'project', recordId], state)
			const { brandProduct } = project

			if (!brandProduct) {
				return false
			}
			if (!isProjectRewardAvailable(project) && !actionPayload.replacementReward) {
				dispatch(
					displayModal(REVIEW_DELIVERY_OPTIONS_MODAL_MODULE_ID, {
						recordClickActionId,
						recordId,
						actionPayload,
						brandProduct,
					}),
				)
				return true
			}

			return false
		},
	},
}
